import { createSelector } from 'reselect';

const selectGlobal = (state) => state.get('modalReducer');


const selectModal = () => createSelector(
  selectGlobal,
  (modalReducer) => modalReducer.get('options').toJS()
);

const selectModalSending = () => createSelector(
  selectGlobal,
  (modalReducer) => modalReducer.get('isSending')
);



export {
  selectGlobal,
  selectModal,
  selectModalSending
};
